<template>
  <div id="app" :class="activepage()">

    <HeaderSection></HeaderSection>

    <div id="curtain"></div>

    <transition
      v-on:before-enter="beforeEnter"
      v-on:enter="enter"
      v-on:after-enter="afterEnter"
      v-on:before-leave="beforeLeave"
      v-on:leave="leave"
      v-on:after-leave="afterLeave"
    >
      <router-view id="wrap" :key="key"></router-view>
    </transition>

  </div>
</template>

<script>

import HeaderSection from './components/global/header.vue'
import ProjectFooter from './components/project/projectFooter.vue'
import pageTransitions from './assets/js/pageTransitions.js'
// import hammer from 'hammerjs'

export default {
  name: 'app',
  data () {
    return {
      pageName: ''
      /* pageOrder: [
        '/',
        '/nutshell'
      ],
      navigationDirection: 'forward' */
    }
  },
  metaInfo: {
    title: 'Full Service Creative Agency',
    titleTemplate: '%s | Blacksheepdesign',
    meta: [
      { vmid: 'description', name: 'description', content: 'A creative agency packing web, design, brands, digital marketing, and communications into one clever team. Great work going worldwide from Palmerston North.' }
    ]
  },
  computed: {
    key () {
      // console.log(this.$route.params)
      var caseID = this.$route.params.id
      var key = ''

      if (!caseID) {
        key = this.$route.meta.key
      } else {
        key = caseID
      }
      return key
    }
  },
  methods: {
    activepage () {
      var location = this.$route.name
      console.log(location)
      return location
    },
    beforeEnter: function (el) {
      var location = this.activepage()
      pageTransitions.beforeEnter(el, location)
    },
    enter: function (el, done) {
      // console.log(el)
      var location = this.activepage()
      pageTransitions.enter(el, location, done)
    },
    afterEnter: function (el, done) {
      var location = this.activepage()
      pageTransitions.afterEnter(el, location, done)
    },
    beforeLeave: function (el) {
      var location = this.activepage()
      pageTransitions.beforeLeave(el, location)
    },
    leave: function (el, done) {
      // console.log(el)
      var location = this.activepage()
      pageTransitions.leave(el, location, done)
    },
    afterLeave: function (el, done) {
      var location = this.activepage()
      pageTransitions.afterLeave(el, location, done)
      // close the menu when the curtain is moving up
      // HAVE COMMENTED THIS OUT SO I CAN TEST THE LOADING NEW PAGE WHEN MENU IS OPEN TRANSITION
      // this.$bus.$emit('closing', {isShowing: false})
    }
    /* nextPage () {
      this.navigationDirection = 'forward'
      const currentPage = this.pageOrder.indexOf(this.$route.path)
      const nextPage = this.pageOrder[currentPage + 1]
      // console.log(nextPage)
      if (nextPage) { this.$router.push(nextPage) }
    },
    prevPage () {
      this.navigationDirection = 'reverse'
      const currentPage = this.pageOrder.indexOf(this.$route.path)
      const prevPage = this.pageOrder[currentPage - 1]
      if (prevPage) { this.$router.push(prevPage) }
    },
    processScroll (e) {
      if (e.deltaY < 0) {
        this.prevPage()
        console.log('prevPage will load')
      }
      if (e.deltaY > 0) {
        this.nextPage()
        console.log('nextPage will load')
      }
    },
    initScroll () {
      var mc = new hammer.Manager(window)
      var swipe = new hammer.Swipe()

      mc.add(swipe)
      mc.on('swipedown', ev => { this.prevPage() })
      mc.on('swipeup', ev => { this.nextPage() })

      var scrollTimer = 0
      var lastScrollFireTime = 0

      window.addEventListener('wheel', e => {
        if (this.pageOrder.indexOf(this.$route.path) + 1) {
          var minScrollTime = 1400
          var now = new Date().getTime()

          if (!scrollTimer) {
            if (now - lastScrollFireTime > minScrollTime) {
              this.processScroll(e)   // fire immediately on first scroll
              lastScrollFireTime = now
            }
          }
        }
      })
    } */
  },
  mounted () {
    // this.initScroll()
  },
  components: {
    HeaderSection,
    ProjectFooter
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  #app.Home{background: rgb(20, 23, 25);}
</style>



// WEBPACK FOOTER //
// src/App.vue